import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';

import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { LayoutCreationDialog } from '../../components/LayoutCreationDialog';
import { AppStyles } from '../../styles/AppTheme';
import { Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';
import LayoutPreview from '../../components/LayoutPreview';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { Toast } from '../../components/Toast';
import { AppHelper } from '../../helpers/AppHelper';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { layotStateOptions } from '../../data/data';
import { SearchBar } from '../../common/components/SearchBar';
export class LayoutsItems extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)

    this.state = {
      ...this.state,
      currentWidth: window.innerWidth,
      currentHeight: window.innerHeight,
      preview: false,
      items: []
    }

    this.pageKey = 'LayoutsItems'
    this.pageTitle = Helper.getString('layouts')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.noTableHead = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('layouts') },
    ]
    this.defaultState = '_ALL'

    this.groupId = this.orgId
    this.toFetch = [
      { method: 'GET', paths: ['layouts'], queryParams: { groupId: this.groupId, state: this.defaultState, pb: 'fieldDef', limit: 100 } }
    ]

    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Image: (current) => {
        const maxWidth = 106
        const maxHeight = 60
        const landscapeSize = AppUiHelper.calculateRenderDimensions(current, maxWidth, maxHeight)
        const portraitSize = AppUiHelper.calculateRenderDimensions(current, maxWidth, maxHeight)
        return (
          <div className={css(Styles.previewThumbnailHolder)} style={{ width: maxWidth, height: maxHeight }} >
            {current.width > current.height && <LayoutPreview renderDimensions={portraitSize} layoutJson={current} />}
            {current.height > current.width && <LayoutPreview renderDimensions={landscapeSize} layoutJson={current} />}
          </div>
        )
      },
      layoutName: (current) => {
        return (
          <div className={css(Styles.layoutDetailsHolder)}>
            <span>{current.title || ''}</span>
          </div>
        )
      },
      State: (current) => {
        return (
          <Fragment>
            {AppUiHelper.itemStatusContainer(current)}
          </Fragment>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.noAdd = true
    this.addNewLabel = Helper.getString('addNewMedia')
    this.actionData = {}
    this.allowAccessToRoles = ['SUPERUSER', 'PARTNER']
    if (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) this.noAdd = true
    this.headerActions = [
      {
        label: Helper.getString('createLayout'),
        icon: 'add',
        onClick: () => this.openLayoutCreator(),
        type: 'icon-mobile'
      }
    ]
  }

  // // ON resize change preview dialog size
  componentDidMount() {
    super.componentDidMount && super.componentDidMount();
    window.addEventListener('resize', this.handleWindowResize)
  }

  componentWillUnmount() {
    super.componentWillUnmount && super.componentWillUnmount();
    window.removeEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize = () => {
    this.setState({
      currentWidth: window.innerWidth,
      currentHeight: window.innerHeight,
    })
  }

  _changePaginationLimit() {
    if(this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 100
  }

  onFetchSuccess(results, opts) {
    // Pagination -- Start
    const { fetchNext } = opts || {}
    if(results[0]) this.handleNextpage(results[0])
    this._changePaginationLimit()
    if (fetchNext) {
      const updatedItems = this.state.items.concat(Helper.dictToArray(results[0].items))
      this.setState({
        items: updatedItems,
        nextPageState: ApiHelper.State.READY,
      })
      return
    }
    // Pagination -- ENDS

    const result = results[0]
    if (!result) {
      return
    }
    this.handleNextpage(results[0])
    this._changePaginationLimit()
    this.setState({
      items: result.items || [],
      stateFilterValue: this.defaultState
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  openLayoutCreator() {
    if(AppHelper.isMobileview()) {
      this.setState({
        toastMsg: Helper.getString('notSupported'),
        showToast: true,
        severity: 'error'
      })
      return
    }
    this.setState({ preview: true })
  }

  //SEARCH filter Dependencies start
  getQueryParams() {
    const queryParams = { }

    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if (this.state.stateFilterValue) {
      queryParams.state = this.state.stateFilterValue
    }
    queryParams.orgId = this.orgId;
    queryParams.limit = 100;
    queryParams.pb = 'fieldDef,fieldDefInstallation,fieldDefVenueGen,fieldDefVenueInfo';
    this.toFetch[0] = { method: 'GET', paths: ['miscs', 'layouts'], queryParams}
    // this.handleNextpage(this.state.item)
    // this._changePaginationLimit()
    console.log(this.toFetch[0])
    return queryParams
  }

  searchHandler() {

    ApiHelper.call(
      {
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'layouts'], this.getQueryParams())
      },
      function (err, data) {
        if (err) {
          this.emptyText = Helper.getErrorMsg(err)
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            item: {},
            items: [],
            nextPage: '',
            inProcessSearch: false,
            inProcessOnList: false
          })
          return
        }
        else {
          this.emptyText = (
            <span className={css(Styles.emptyTextHolder)}>
              <span>{Helper.getString('noLayout')}</span>
            </span>
          )
          this.handleNextpage(data)
          this._changePaginationLimit()
          this.setState({
            successMsg: '',
            item: data,
            items: data.items,
            errMsg: null,
            inProcessSearch: false,
            inProcessOnList: false
          })
        }
      }.bind(this));
  }

  onList() {
    if (this.searchBarComponent) this.searchBarComponent.setState({ searchText: '' })
    this.setState({ searchText: '', inProcessOnList: true, stateFilterValue: this.defaultState }, () => this.searchHandler())
  }

  onSearch = (searchText) => {
    this.setState({ searchText: searchText, inProcessSearch: true }, () => { this.searchHandler() })
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue: selectedState
    })
  }
  //SEARCH filter Dependencies end

  renderAboveTable() {
    return (
      <Fragment>
        <SearchBar
          ref={(child) => (this.searchBarComponent = child)}
          hint={'Search'}
          inProcessSearch={this.state.inProcessSearch || false}
          inProcessOnList={this.state.inProcessOnList || false}
          onList={this.onList.bind(this)}
          onSearch={this.onSearch.bind(this)}
          searchText={this.state.searchText}
          onSinglePickerFilter={this.onStateFilter.bind(this)}
          singleSelectPicker={
            {
              options: layotStateOptions,
              defaultValue: this.state.stateFilterValue,
              // title: 'Select State'
            }
          }
          showRecentButtonText={'Reset Filter'} />
        {this.getToast()}
        {this.state.displayPreview && (
          <div className={css(Styles.fullScreenDialog)}>
            {/* Close button */}
            <span className={css(Styles.closeButton)} onClick={() => this.setState({ displayPreview: false })}>
              <span className='material-icons-outlined'>cancel</span>
            </span>

            {/* Full-screen layout preview */}
            <LayoutPreview renderDimensions={{ width: this.state.currentWidth, height: this.state.currentHeight }} layoutJson={this.state.selectedLayout} resize='fit' />
          </div>
        )}
        {this.state.preview &&
          <LayoutCreationDialog
            successCallback={this.onLayoutCreationSuccess}
            orgId={this.orgId}
            isOpen={this.state.preview ? true : false}
            onClosed={() => this.setState({ preview: false })}
          />
        }
      </Fragment>
    )
  }
  onLayoutCreationSuccess = () => {
    this.setState({ preview: false })
    this.fetchItems()
  }
  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, this.editLayout(current), this.allowAccessToRoles)
    return actions
  }

  editLayout(current) {
    if(AppHelper.isMobileview()) {
      return (
        <Tooltip title={Helper.getString('edit')} placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)} onClick={() => {
            this.setState({
              toastMsg: Helper.getString('notSupported'),
              showToast: true,
              severity: 'error'
            })
          }}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      )
    }
    return (
      <Link to={this.baseRoute() + '/layouts/' + current.id} key={current.id + '-layout'}>
        <Tooltip title={Helper.getString('edit')} placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

}

const Styles = StyleSheet.create({
  previewThumbnailHolder: {
    display: 'flex',
    justifyContent: 'center'
  },
  layoutDetailsHolder: {
    width: 500
  },
  fullScreenDialog: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    cursor: 'pointer',
    fontSize: 24,
    color: '#fff',
    zIndex: 10000,
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/LayoutsItems.js